import { FirebaseApp, initializeApp } from "firebase/app";

let _app: FirebaseApp | null;
export function getDefaultFirebaseApp(): FirebaseApp {
  if (!_app) {
    _app = initializeApp({
      apiKey: "AIzaSyDjQ3xul33xkla9gJSBtpi6zpa4k90_fgw",
      authDomain: "fahm-8cea6.firebaseapp.com",
      projectId: "fahm-8cea6",
      storageBucket: "fahm-8cea6.firebasestorage.app",
      messagingSenderId: "601164224578",
      appId: "1:601164224578:web:53d40150cc2e1afb0af5db",
    });
  }
  return _app;
}
